import { WebAuth } from 'auth0-js'
import config from '../config'

class Auth0OIDCAuthentication {
  private domain: string
  private clientID: string
  private redirectUrl: string
  private apiIdentifier: string
  private webAuth: WebAuth

  constructor() {
    this.domain = config.oidcDomain
    this.clientID = config.oidcClientId
    this.redirectUrl = window.location.origin + config.oidcRedirectPath || ''
    this.apiIdentifier = config.oidcMgmtApiIdentifier
    this.webAuth = new WebAuth({
      domain: this.domain,
      clientID: this.clientID,
    })
  }

  public login(connection: string): void {
    this.webAuth.authorize({
      connection,
      responseType: 'code',
      scope: 'openid email offline_access',
      audience: this.apiIdentifier,
      redirectUri: this.redirectUrl,
    })
  }

  public logout(returnTo?: string): void {
    this.webAuth.logout({
      returnTo,
      clientID: this.clientID,
    })
  }
}

export default new Auth0OIDCAuthentication()
